import { STATUS_MAP } from '@/pages/companies/_company_id/projects/_id/attendance/utils';
import { AttendanceDisplayStatus } from '@/types/attendance';
export function stampStatusToLabel(status) {
    if (status === AttendanceDisplayStatus.MISSING_STAMP) {
        return STATUS_MAP[AttendanceDisplayStatus.MISSING_STAMP].getDisplayValue(0);
    }
    return null;
}
export function formatTimeProject(timeStr) {
    if (!timeStr || typeof timeStr !== 'string')
        return '';
    if (timeStr.match(/^\d{2}:\d{2}:\d{2}$/)) {
        return timeStr.slice(0, 5);
    }
    if (timeStr.match(/^\d{2}:\d{2}$/)) {
        return timeStr;
    }
    return '';
}
export function buildAllocationTaskFromApiProject(project, process) {
    return {
        id: String((process === null || process === void 0 ? void 0 : process.id) || ''),
        projectId: String((project === null || project === void 0 ? void 0 : project.id) || ''),
        largeProcessId: (process === null || process === void 0 ? void 0 : process.id) ? String(process.id) : null,
        projectName: (project === null || project === void 0 ? void 0 : project.title) || '',
        processName: (process === null || process === void 0 ? void 0 : process.name) || '',
        startTime: formatTimeProject(process === null || process === void 0 ? void 0 : process.start_time),
        endTime: formatTimeProject(process === null || process === void 0 ? void 0 : process.end_time),
        timeOverlap: !!(process === null || process === void 0 ? void 0 : process.time_overlap),
        statusLabel: stampStatusToLabel(process === null || process === void 0 ? void 0 : process.stamp_status)
    };
}
/** HH:mm or HH:mm:ss → HH:mm:ss for member-allocation assign/update/conflict APIs. */
export function formatTimeForMemberAllocationApi(timeStr) {
    if (!timeStr || typeof timeStr !== 'string')
        return '';
    var trimmed = timeStr.trim();
    if (/^\d{2}:\d{2}:\d{2}$/.test(trimmed))
        return trimmed;
    if (/^\d{2}:\d{2}$/.test(trimmed))
        return trimmed + ":00";
    return '';
}
